import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ClientFilterFragment = { id: string, clientName: string, clientIcon?: { url?: string | null } | null };


export type ClientFilterFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ClientFilterFragmentDoc = /*#__PURE__*/ gql`
    fragment ClientFilter on ClientType {
  id
  clientName
  clientIcon {
    url
  }
}
    `;